export default __webpack_public_path__ + "static/foto-4-c3a7ac478d65cd4f0835ec3586fac75b.jpg";